import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from './messages/ContactPersonForm_messages';
import propMessages from './messages/ContactPersonProps_messages';

import Button from '../../components/Button';
import { Input, InputGroup, Label } from '../../components/Form';
import LoadingIndicator from '../../components/LoadingIndicator';

const propTypes = {
  cancelAdd: PropTypes.func,
  cancelUpdate: PropTypes.func,
  children: PropTypes.func,
  externalControls: PropTypes.bool,
  isAdd: PropTypes.bool,
  isUpdate: PropTypes.bool,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  toUpdate: PropTypes.object,
  working: PropTypes.bool,
};

const defaultProps = {
  cancelAdd: () => {},
  cancelUpdate: () => {},
  children: () => {},
  externalControls: false,
  isAdd: true,
  isUpdate: false,
  onAdd: () => {},
  onUpdate: () => {},
  toUpdate: null,
  working: false,
};

class ContactPersonForm extends Component {
  constructor(props) {
    super(props);
    this.state = this.getStateFromProps();
  }

  /* eslint-disable react/no-did-update-set-state */
  componentDidUpdate(prevProps) {
    const prevToUpdateId = prevProps.toUpdate ? prevProps.toUpdate.id : null;
    const toUpdateId = this.props.toUpdate ? this.props.toUpdate.id : null;
    if (prevToUpdateId !== toUpdateId
      || prevProps.isUpdate !== this.props.isUpdate
      || prevProps.isAdd !== this.props.isAdd) {
      this.setState(this.getStateFromProps());
    }
  }
  /* eslint-enable react/no-did-update-set-state */

  getStateFromProps = () => ({
    email: this.isUpdate ? this.props.toUpdate.email : '',
    firstName: this.isUpdate ? this.props.toUpdate.firstName : '',
    lastName: this.isUpdate ? this.props.toUpdate.lastName : '',
    phone: this.isUpdate ? this.props.toUpdate.phone : '',
  });

  getValueSetter = key => evnt => {
    this.setState({ [key]: evnt.target.value });
  }

  cancel = evnt => {
    evnt.preventDefault();
    if (this.props.isAdd) {
      this.props.cancelAdd();
    } else if (this.props.isUpdate) {
      this.props.cancelUpdate();
    }
  }

  submit = evnt => {
    evnt.preventDefault();
    if (!this.props.working && this.isValid) {
      const contactPerson = this.sanitizedData;
      if (this.isAdd) {
        this.props.onAdd({ contactPerson });
      } else if (this.isUpdate) {
        contactPerson.id = this.props.toUpdate.id;
        this.props.onUpdate({ contactPerson });
      }
    }
  }

  get sanitizedData() {
    const { email, firstName, lastName, phone } = this.state;
    return {
      email: (email || '').trim(),
      firstName: (firstName || '').trim(),
      lastName: (lastName || '').trim(),
      phone: (phone || '').trim(),
    };
  }

  get isAdd() {
    return this.props.isAdd;
  }

  get isUpdate() {
    return this.props.isUpdate;
  }

  get isValid() {
    const sanitized = this.sanitizedData;
    return (
        sanitized.firstName
        && sanitized.lastName
        && (sanitized.email || sanitized.phone));
  }

  get submitLabel() {
    if (this.isAdd) {
      return <FormattedMessage { ...messages.addButtonLabel } />;
    }
    return <FormattedMessage { ...messages.updateButtonLabel } />;
  }

  render = () =>
    <React.Fragment>
      <InputGroup>
        <Label htmlFor='contact-person-first-name'>
          <FormattedMessage { ...propMessages.firstNameLabel } />
        </Label>
        <Input
          disabled={this.props.working}
          id='contact-person-first-name'
          onChange={this.getValueSetter('firstName')}
          type='text'
          value={this.state.firstName}
        />
      </InputGroup>
      <InputGroup>
        <Label htmlFor='contact-person-last-name'>
          <FormattedMessage { ...propMessages.lastNameLabel } />
        </Label>
        <Input
          disabled={this.props.working}
          id='contact-person-last-name'
          onChange={this.getValueSetter('lastName')}
          type='text'
          value={this.state.lastName}
        />
      </InputGroup>
      <InputGroup>
        <Label htmlFor='contact-person-phone'>
          <FormattedMessage { ...propMessages.phoneLabel } />
        </Label>
        <Input
          disabled={this.props.working}
          id='contact-person-phone'
          onChange={this.getValueSetter('phone')}
          type='phone'
          value={this.state.phone}
        />
      </InputGroup>
      <InputGroup>
        <Label htmlFor='contact-person-email'>
          <FormattedMessage { ...propMessages.emailLabel } />
        </Label>
        <Input
          disabled={this.props.working}
          id='contact-person-email'
          onChange={this.getValueSetter('email')}
          type='email'
          value={this.state.email}
        />
      </InputGroup>
      {this.props.externalControls && this.props.children({
        isAdd: this.isAdd,
        isUpdate: this.isUpdate,
        isValid: this.isValid,
        submit: this.submit,
      })}
      {!this.props.externalControls && (
        <React.Fragment>
          <Button
            disabled={!this.isValid || this.props.working}
            id='contact-person-form-submit-button'
            onClick={this.submit}
          >
            {this.props.working && <LoadingIndicator />}
            {this.submitLabel}
          </Button>
          <Button
            disabled={this.props.working}
            onClick={this.cancel}
            id='contact-person-form-cancel-button'
            color='orange'
          >
            <FormattedMessage { ...messages.cancelButtonLabel } />
          </Button>
        </React.Fragment>
      )}
    </React.Fragment>;
}

ContactPersonForm.propTypes = propTypes;
ContactPersonForm.defaultProps = defaultProps;

export default ContactPersonForm;
